/**
 * Header component.
 */

import './_header.scss';
import { ApplicationContext } from '../../common/context';
import { Button, Select } from 'antd';
import { FormattedMessage, useIntl } from "react-intl";
import React, { useContext } from 'react';


const { Option } = Select;

const Header = ({language, onChangeLanguage}) => {
  const context = useContext(ApplicationContext);
  const tab = context.tab;

  /**
   * Change Language.
   */

  const handleChangeLanguage = (value) => {
    onChangeLanguage(value);
  }

  return (
    <div className={'header'}>
      <div className={'header__left'}>
        <a href={'/'}>
          <img
            alt={'cotec - matriz'}
            src={'cotec-logo.svg'}
          />
        </a>
      </div>
      <div className={'header__right'}>
        <a
          alt={'Cotec Tools'}
          className={'header__btn-link'}
          href={useIntl().formatMessage({ id: 'header.linkTools' })}
        >
          <img
            alt={'Cotec Tools'}
            src={'icons/tools.svg'}
          />
        </a>

        <Select defaultValue={language} style={{ width: 120, marginRight: 20}} onChange={handleChangeLanguage}>
          <Option value="pt">Português</Option>
          <Option value="en">English</Option>
        </Select>

        {tab === '1' ? (
          <div>
            <Button
              onClick={() => context.handleChangeTab('2')}
              type={'primary'}
            >
              <FormattedMessage id="header.init"/>
            </Button>
          </div>
        ) : null}
        {tab === '2' ? (
          <div>
            <Button
              onClick={() => context.handleChangeTab('3')}
              type={'primary'}
            >
              <FormattedMessage id="header.results"/>
            </Button>
          </div>
        ) : null}
        {tab === '3' ? (
          <div className={'header__right-buttons-wrap'}>
            <Button
              className={'tab3-edit-btn'}
              onClick={() => context.handleChangeTab('2')}
              type={'secondary'}
            >
              <FormattedMessage id="header.edit"/>
            </Button>
            <Button
              onClick={() => context.print()}
              type={'primary'}
            >
              <FormattedMessage id="header.print"/>
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Header;
